import React, { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

interface PayoutCompletionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (transactionId: string) => void;
  Loading: boolean;
}

const PayoutCompletionModal: React.FC<PayoutCompletionModalProps> = ({ open, onClose, onConfirm, Loading }) => {
  const [transactionId, setTransactionId] = useState("");

  const handleConfirm = () => {
    if (transactionId) {
      onConfirm(transactionId);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-container">
          <div className="modal-header">
            <h2>Payout Completion</h2>
            <button onClick={onClose} className="close-button">
              &times;
            </button>
          </div>
          <div className="modal-body">
            <label htmlFor="transactionId" className="input-label">
              Transaction ID
            </label>
            <input
              type="text"
              id="transactionId"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              className="input-field"
            />
          </div>
          <div className="modal-footer">
            <button onClick={handleConfirm} className="confirm-button" disabled={Loading}>
              {Loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>

      {/* Backdrop for loading */}
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default PayoutCompletionModal;
